import type { FreeBusyStatus, BusyType } from 'owa-graph-schema';

export default function convertFreeBusyStatusToBusyType(status: FreeBusyStatus): BusyType {
    switch (status) {
        case 'Unknown':
            return 'NoData';
        case 'Free':
            return 'Free';
        case 'Tentative':
            return 'Tentative';
        case 'Busy':
            return 'Busy';
        case 'Oof':
            return 'OOF';
        case 'WorkingElsewhere':
            return 'WorkingElsewhere';
        default:
            throw new Error('Invalid value for type FreeBusyStatus');
    }
}
